import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type KnowledgeAssetContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, description?: string | null, status: Types.ResourceStatusEnum, knowledgeAssetSubType?: Types.KnowledgeAssetSubTypeEnum | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };


export type KnowledgeAssetContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const KnowledgeAssetContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment KnowledgeAssetContentCard on KnowledgeAssetContentType {
  id
  name
  type
  description
  status
  cover {
    ...EntityMedia
  }
  knowledgeAssetSubType
}
    `;